import { getFontSize } from "../utils/getFontSize";

export const subsectionTitle = {
  fontWeight: 500,
  letterSpacing: 3,
  fontSize: getFontSize(12),
  marginBottom: 5,
  textTransform: "uppercase",
};
